module.exports = __webpack_public_path__ + "img/sliderBtnLeft.b00481f3.svg";